// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".p-20[data-v-7a5819bd] {\n  padding: 20px;\n}\n.action-buttons[data-v-7a5819bd] {\n  display: flex;\n}\n.login-btn[data-v-7a5819bd] {\n  margin-right: 15px;\n}\n.refresh-dialog[data-v-7a5819bd] {\n  z-index: 1200;\n}\n.blur-background[data-v-7a5819bd] {\n  position: fixed;\n  top: 0px;\n  left: 0px;\n  right: 0px;\n  bottom: 0px;\n  -webkit-backdrop-filter: blur(10px);\n          backdrop-filter: blur(10px);\n  z-index: 1100;\n}\n", ""]);
// Exports
module.exports = exports;
